"use client";

import { mobileNavBarItems } from "@/constants";
import { cn } from "@/lib";
import Link from "next/link";
import { CustomButton, FlexCenter } from "./ui";
import AppContainer from "./appContainer";
import { useSession } from "next-auth/react";
import { useModalStore } from "@/store";
import { BdLogin3, BdUser } from "solar-icon-react/bd";
import ProfileDropdown from "./profileDropdown";
import { useState } from "react";
import { routes } from "@/routes";
import { useTranslations } from "next-intl";

interface IMobileNavbarProps {
  className?: string;
}

const MobileNavbar = ({ className }: IMobileNavbarProps) => {
  const t = useTranslations();
  const { status } = useSession();
  const { setOpenModal } = useModalStore();
  const isLoggedIn = status === "authenticated";
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenSideBar = () => {
    setOpenModal("sidebar");
  };

  const handleToggleUserDropdown = () => {
    setIsOpen((state) => !state);
  };

  return (
    <>
      <nav
        className={cn(
          "md:hidden",
          "bg-surface-navbar shadow-main fixed right-0 bottom-0 left-0 z-50 w-full",
          className,
        )}
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <AppContainer className={cn("h-auto")}>
          <ul className={cn("mx-auto flex items-center justify-between")}>
            {mobileNavBarItems.map((item, index) => (
              <li className={cn("py-3 text-white")} key={index}>
                <Link
                  id={`mobile-nav-${item.id}`}
                  title={t(item.label as any)}
                  href={item.href || "#"}
                >
                  <div
                    className={cn(
                      "flex flex-col items-center justify-center gap-2 p-0",
                      "text-micro sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl",
                    )}
                    onClick={() => {
                      if (t(item.label as any) === t("mobileNav.services")) {
                        handleOpenSideBar();
                      }
                    }}
                  >
                    <FlexCenter
                      className={cn(
                        "size-8 shrink-0 text-white",
                        "w-8 lg:w-9 xl:w-10 2xl:w-11",
                      )}
                    >
                      {item.icon && item.icon}
                    </FlexCenter>
                    <h2 className="flex w-full justify-center">
                      {t(item.label as any)}
                    </h2>
                  </div>
                </Link>
              </li>
            ))}
            {isLoggedIn ? (
              <li
                className={cn(
                  "relative flex flex-col items-center justify-center gap-2 py-3 text-white",
                )}
                onClick={handleToggleUserDropdown}
              >
                <FlexCenter
                  className={cn(
                    "size-8 shrink-0 text-white",
                    "w-8 lg:w-9 xl:w-10 2xl:w-11",
                  )}
                >
                  <BdUser className={cn("size-full!")} />
                </FlexCenter>
                <CustomButton
                  className={cn(
                    "bg-transparent p-0",
                    "text-micro sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl",
                  )}
                >
                  {t("header.profile")}
                </CustomButton>
                {isOpen && <ProfileDropdown pointerPosition="down" />}
              </li>
            ) : (
              <li
                className={cn(
                  "flex flex-col items-center justify-center py-3 text-white md:gap-2",
                )}
              >
                <Link
                  title={t("header.login")}
                  href={routes.auth.SEND_OTP.primaryPath}
                >
                  <div
                    className={cn(
                      "text-white",
                      "w-8 lg:w-9 xl:w-10 2xl:w-11",
                    )}
                  >
                    <BdLogin3 className={cn("size-full!")} />
                  </div>
                  <CustomButton
                    className={cn(
                      "bg-transparent p-0",
                      "text-micro sm:text-xs md:text-sm lg:text-base xl:text-lg 2xl:text-xl",
                    )}
                  >
                    {t("header.login")}
                  </CustomButton>
                </Link>
              </li>
            )}
          </ul>
        </AppContainer>
      </nav>
      <div
        aria-hidden="true"
        className="md:hidden"
        style={{ height: "calc(80px + env(safe-area-inset-bottom))" }}
      />
    </>
  );
};

export default MobileNavbar;
